import { UseFormReturn, useWatch, yupResolver } from '@slal/ui/react-hook-form/core';
import { FormEventHandler, useCallback } from 'react';
import { useNavigate } from 'react-router';
import { useAnalytics, useApplicationForm } from '~/hooks';
import { keyConsiderationsValidationSchema } from '~/schemas';
import { ApplicationFormKeys, KeyConsiderationsSchema, MainPlanOptions } from '~/types';

type UseKeyConsiderationsApplicationFormProps = {
    form: UseFormReturn<KeyConsiderationsSchema>;
    handleSubmit: FormEventHandler;
    name: string;
    option?: string & MainPlanOptions;
};

export const useKeyConsiderationsApplicationForm = (
    key: string,
    nextRoute: string
): UseKeyConsiderationsApplicationFormProps => {
    const name = `keyConsiderations.${key}`;
    const { handleSubmit, form } = useApplicationForm<KeyConsiderationsSchema>(
        {
            resolver: yupResolver(keyConsiderationsValidationSchema(key)),
        },
        ApplicationFormKeys.KEY_CONSIDERATIONS
    );

    const option = useWatch({
        control: form.control,
        name: name as 'keyConsiderations' | `keyConsiderations.${string}`,
    });

    const navigate = useNavigate();
    const { pushEvent } = useAnalytics();
    const onValidCallback = useCallback(() => {
        navigate(nextRoute);
        pushEvent({ eventLabel: `${option} selected` });
    }, [navigate, option]);

    return { form, handleSubmit: handleSubmit(onValidCallback), name, option };
};
